import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// POST /ajax/family/save_notification_settings
export const saveNotificationSettings = async (payload: Object): Promise<any> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post('/ajax/family/save_notification_settings', payload)
      .then((response: any) => {
        resolve(Util.Obj.keysToCamel(response.data))
      })
      .catch((err: any) => {
        reject(err.responseText)
      })
  })
}
